import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_CLIENT_SERVICE_BASE,
  getClientOptions(clientId) {
    return axios
      .get(`${this.baseUrl}/GetClientOptions/${clientId}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  loadBillingStructures() {
    return axios
      .get(`${this.baseUrl}/GetClientBillingTypes`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  loadBillingLineItems() {
    return axios
      .get(`${this.baseUrl}/GetBillingLineItems`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  loadClientDetails(clientId) {
    return axios
      .get(`${this.baseUrl}/GetClientDetails/${clientId}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  loadClients() {
    return axios
      .get(`${this.baseUrl}/GetClients?isActive=true`, {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      })
      .then(response => {
        return response.data;
      });
  },
  loadOptionsList() {
    return axios
      .get(`${this.baseUrl}/GetOptions`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  loadScriptTypes() {
    return axios
      .get(`${this.baseUrl}/GetScriptTypes`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  saveClientOptions(options) {
    return axios
      .post(`${this.baseUrl}/SetClientOptions`, options, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data.Result;
      });
  },
  saveClientDetails(client) {
    return axios
      .post(`${this.baseUrl}/SaveClientDetail`, client, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data.Result;
      });
  }
};
